<template>
  <page-result
    v-if="isError"
    :image="imgError"
    title="错误提示"
    desc="请在微信或支付宝中打开该链接"
  />
  <router-view v-else />
</template>

<script>
import PageResult from '@/components/PageResult';
import imgError from '@/assets/img-status-error.png';
import * as utils from '@/utils';
import { initRecorder } from '@/core/recorder';

export default {
  name: 'CheckClientEnv',
  components: {
    PageResult,
  },
  mounted() {
    initRecorder();
  },
  updated() {},
  data() {
    const isDev = process.env.NODE_ENV === 'development';
    const client = utils.getClientEnv();
    const platform = utils.getPlatform();
    const isPayPath = window.location.pathname === '/insurance-form-payment';
    // const isError = isPayPath
    //   ? false
    //   : !isDev && client === 'browser' && platform !== 'ios';
    const isError = false;
    return {
      isError,
      imgError,
    };
  },
};
</script>
